<svelte:options customElement="clw-icon-autocolor" />

<script lang="ts">
    export let fillColor = 'white';
    export let strokeColor = 'white';
</script>

<svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-action-button"
>
    <path
        d="M20.2435 8.02446C20.8243 9.22057 21.1501 10.5638 21.1501 11.9821C21.1501 16.9944 17.0872 21.0572 12.075 21.0572C9.6002 21.0572 7.35945 19.941 5.72229 18.3347"
        stroke={strokeColor}
        stroke-width="1.81503"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M3.90752 15.9441C3.32579 14.7471 3.00006 13.4031 3.00006 11.9829C3.00006 6.97156 7.06292 2.90771 12.0751 2.90771C14.5491 2.90771 16.7907 4.02486 18.4278 5.63026"
        stroke={strokeColor}
        stroke-width="1.81503"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M18.4276 2V5.63016H14.7976"
        stroke={strokeColor}
        stroke-width="1.81503"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M5.72247 21.9654V18.3353H9.35245"
        stroke={strokeColor}
        stroke-width="1.81503"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <circle cx="13.2704" cy="13.8577" r="3.42885" fill={fillColor} />
    <circle cx="10.4289" cy="10.4289" r="2.79726" stroke={strokeColor} stroke-width="1.2632" />
</svg>
